import 'babel-polyfill'

import React, { Suspense } from 'react'
import { render } from 'react-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import buildInfo, { buildTag } from 'utils/buildInfo'
import environment, { isProd } from 'utils/environment'
import 'utils/polyfills'
import i18nextInit from 'i18n'
import BouncingBallLoader from 'components/uiElements/BouncingBallLoader'
import SugarcubeContainer from 'apps/sugarcube/SugarcubeContainer'
import ErrorMessage from 'components/ErrorMessage'
import { history } from 'configureStore'

// eslint-disable-next-line no-console
console.log(buildInfo)

Sentry.init({
    release: buildTag,
    dsn: 'https://39a1b642333d427a81f16ed5eb7d8894@o250847.ingest.sentry.io/5339839',
    environment,
    integrations: [
        new Integrations.BrowserTracing({
            tracingOrigins: ['develop.mysugarcube.com', 'ww8.ikea.com', 'www.ikea.com'],
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
    ],
    tracesSampleRate: isProd ? 0.2 : 1.0,
})

const onI18nError = (err) => {
    if (err) {
        Sentry.captureException(new Error(err))
        render(<ErrorMessage />, document.getElementById('Root'))
    }
}
i18nextInit(onI18nError)

render(
    <Sentry.ErrorBoundary fallback={<ErrorMessage />}>
        <Suspense fallback={<BouncingBallLoader />}>
            <SugarcubeContainer />
        </Suspense>
    </Sentry.ErrorBoundary>,
    document.getElementById('Root'),
)
